import { slideOut } from '../animations';

export default function startStep(presentation) {
  const { elements } = presentation;

  // console.log('start', elements);

  const { start } = elements;

  presentation.addStep({
    id: 'start',
    default: {
      leave: slideOut(start),
    },
  });
}

startStep.startAnimation = function startAnimation(presentation, timeline) {
  const { elements, breakpoint } = presentation;

  // console.log('start', elements);

  const {
    logoO,
    logoA,
    logoOSmall,
    logoW,
    startLeft,
    startRight,
    startArrowWrapper,
    startArrowButton,
  } = elements;

  startArrowButton.addEventListener('click', () => presentation.next());

  const time = 2;
  const timeWait = 0;
  const timeText = 1;
  const logoLetters = [logoO, logoA, logoW];
  const isVertical = breakpoint === 'default' || breakpoint === 'small';

  const leftBoxFull = startLeft.getBoundingClientRect();
  const rightBoxFull = startRight.getBoundingClientRect();
  startRight.style[isVertical ? 'height' : 'maxWidth'] = '0';
  const leftBox = startLeft.getBoundingClientRect();

  const logoOBox = logoO.getBoundingClientRect();
  const logoABox = logoA.getBoundingClientRect();
  const logoOAdjust =
    logoOBox.width * (leftBox.height / logoOBox.height) * 0.59;
  const logoAAdjust =
    logoABox.width * (leftBox.height / logoABox.height) * 0.58;

  timeline
    .set(logoOSmall, { opacity: 0 })
    .to(logoLetters, time, { scale: 0.05, opacity: 1 })
    .fromTo(
      logoO,
      time,
      { x: -logoOBox.width, y: 0 },
      { x: leftBox.left, y: leftBox.top },
      0,
    )
    .fromTo(
      logoA,
      time,
      {
        x: window.innerWidth / 3,
        y: window.innerHeight - logoABox.height / 3,
        rotation: 30,
      },
      { x: leftBox.left + logoOAdjust, y: leftBox.top, rotation: 0 },
      0,
    )
    .fromTo(
      logoW,
      time,
      { x: window.innerWidth, y: 0, rotation: 40 },
      {
        x: leftBox.left + logoOAdjust + logoAAdjust,
        y: leftBox.top,
        rotation: 0,
      },
      0,
    )
    .addLabel('text', time + timeWait);

  if (isVertical) {
    timeline
      .to(
        logoLetters,
        timeText,
        { y: `-=${leftBox.top - leftBoxFull.top}` },
        'text',
      )
      .fromTo(
        startRight,
        timeText,
        { height: 0 },
        { height: rightBoxFull.height },
        'text',
      );
  } else {
    timeline
      .to(
        logoLetters,
        timeText,
        { x: `-=${leftBox.left - leftBoxFull.left}` },
        'text',
      )
      .fromTo(
        startRight,
        timeText,
        { maxWidth: 0 },
        { maxWidth: rightBoxFull.width },
        'text',
      );
  }

  timeline.set(startArrowWrapper, { className: '+=is-visible' });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/start.js